'use client'

import { CMSLink } from '@/components/Link'
import Link from 'next/link'

import { ChevronDown, ChevronsRight } from 'lucide-react'
import SubMenu from './sub-menu'

export const Header5 = ({
  navItems,
  logo,
  rightCta,
}: {
  navItems: any
  logo: any
  rightCta?: any
}) => {
  return (
    <div className="bg-primary py-3  px-4 shadow-md">
      <div className="max-w-7xl mx-auto flex items-center space-x-24">
        <div className="relative">
          <Link href="/" className="">
            {logo?.url && (
              <img
                src={logo?.url}
                alt="Titan Fence & Supply Company - Est. 2009 - Crossroads, Texas"
                className=" w-32 h-auto cursor-pointer "
              />
            )}
          </Link>
        </div>
        <div className="flex items-center gap-8 flex-1 justify-center  ">
          {navItems?.map((item: any, index: any) => {
            return (
              <div
                className="text-left cursor-pointer relative group "
                key={`index-${index}-${item?.link?.label}`}
              >
                <Link
                  href={item?.link?.url || '/'}
                  className="flex items-center  text-[18px] font-medium capitalize text-white relative z-[1] transition-all duration-500"
                >
                  <h3 className="text-[16px] text-white transition-colors group font-bold">
                    {item?.link?.label}
                  </h3>
                  {!!item?.subMenuItems?.length && (
                    <ChevronDown className="text-white text-[16px] font-bold" />
                  )}
                  <span className="absolute h-[2px] bottom-0 bg-red-500   scale-x-0 group-hover:scale-x-100 transition-transform  z-[-1] w-full"></span>
                </Link>

                {!!item?.subMenuItems?.length && <SubMenu items={item?.subMenuItems} />}
              </div>
            )
          })}
        </div>
        {rightCta &&
          rightCta?.map((item: any, index: any) => {
            return (
              <div
                className="relative overflow-hidden group rounded-full inline-flex"
                key={item?.id || index}
              >
                <div className="z-10 absolute inset-0 bg-card origin-center rotate-[-45deg] scale-y-0 group-hover:scale-y-[5] transition-transform duration-500 ease-in-out rounded-full" />
                <Link
                  href={item?.link?.url || '/'}
                  className="relative  inline-flex   items-center border hover:border-border border-destructive cursor-pointer text-white font-semibold text-base tracking-wide rounded-full px-6 py-5 bg-destructive hover:bg-card transition-all duration-500 ease-out"
                >
                  <div className="flex flex-row items-center justify-center z-10 group-hover:text-black font-light">
                    {item?.link?.label}
                    <ChevronsRight className="ml-2 " />
                  </div>
                </Link>
              </div>
            )
          })}
      </div>
    </div>
  )
}
